import React, { useId } from "react";
import PropTypes from "prop-types";

const paths = [
  "M6.05203 1.25C6.9505 1.24997 7.69971 1.24995 8.29448 1.32991C8.92228 1.41432 9.48908 1.59999 9.94455 2.05546C10.4 2.51093 10.5857 3.07773 10.6701 3.70552C10.7501 4.3003 10.75 5.04954 10.75 5.94801V8.05203C10.75 8.9505 10.7501 9.69971 10.6701 10.2945C10.5857 10.9223 10.4 11.4891 9.94455 11.9445C9.48908 12.4 8.92228 12.5857 8.29448 12.6701C7.69971 12.7501 6.95047 12.75 6.052 12.75H5.94798C5.04951 12.75 4.3003 12.7501 3.70552 12.6701C3.07773 12.5857 2.51093 12.4 2.05546 11.9445C1.59999 11.4891 1.41432 10.9223 1.32991 10.2945C1.24995 9.69971 1.24997 8.95047 1.25 8.052V5.94797C1.24997 5.04951 1.24995 4.3003 1.32991 3.70552C1.41432 3.07773 1.59999 2.51093 2.05546 2.05546C2.51093 1.59999 3.07773 1.41432 3.70552 1.32991C4.3003 1.24995 5.04954 1.24997 5.948 1.25H6.05203Z",
  "M7.02527 15.25C7.46972 15.25 7.84076 15.25 8.14537 15.2708C8.46247 15.2924 8.76199 15.3391 9.05238 15.4593C9.72621 15.7384 10.2616 16.2738 10.5407 16.9476C10.661 17.238 10.7076 17.5375 10.7292 17.8546C10.75 18.1592 10.75 18.5303 10.75 18.9747V19.0253C10.75 19.4697 10.75 19.8408 10.7292 20.1454C10.7076 20.4625 10.661 20.762 10.5407 21.0524C10.2616 21.7262 9.72621 22.2616 9.05238 22.5407C8.76199 22.661 8.46247 22.7076 8.14537 22.7292C7.84076 22.75 7.46972 22.75 7.02526 22.75H4.97475C4.53029 22.75 4.15925 22.75 3.85464 22.7292C3.53754 22.7076 3.23801 22.661 2.94762 22.5407C2.2738 22.2616 1.73844 21.7262 1.45933 21.0524C1.33905 20.762 1.29241 20.4625 1.27077 20.1454C1.24999 19.8408 1.25 19.4697 1.25 19.0253V18.9747C1.25 18.5303 1.24999 18.1592 1.27077 17.8546C1.29241 17.5375 1.33905 17.238 1.45933 16.9476C1.73844 16.2738 2.2738 15.7384 2.94762 15.4593C3.23801 15.3391 3.53754 15.2924 3.85464 15.2708C4.15925 15.25 4.5303 15.25 4.97475 15.25H7.02527Z",
  "M18.052 11.25C18.9505 11.25 19.6997 11.2499 20.2945 11.3299C20.9223 11.4143 21.4891 11.6 21.9445 12.0555C22.4 12.5109 22.5857 13.0777 22.6701 13.7055C22.7501 14.3003 22.75 15.0495 22.75 15.948V18.052C22.75 18.9505 22.7501 19.6997 22.6701 20.2945C22.5857 20.9223 22.4 21.4891 21.9445 21.9445C21.4891 22.4 20.9223 22.5857 20.2945 22.6701C19.6997 22.7501 18.9505 22.75 18.052 22.75H17.948C17.0495 22.75 16.3003 22.7501 15.7055 22.6701C15.0777 22.5857 14.5109 22.4 14.0555 21.9445C13.6 21.4891 13.4143 20.9223 13.3299 20.2945C13.2499 19.6997 13.25 18.9505 13.25 18.052V15.948C13.25 15.0495 13.2499 14.3003 13.3299 13.7055C13.4143 13.0777 13.6 12.5109 14.0555 12.0555C14.5109 11.6 15.0777 11.4143 15.7055 11.3299C16.3003 11.2499 17.0495 11.25 17.948 11.25H18.052Z",
  "M19.0253 1.25C19.4697 1.25 19.8408 1.24999 20.1454 1.27077C20.4625 1.29241 20.762 1.33905 21.0524 1.45933C21.7262 1.73844 22.2616 2.2738 22.5407 2.94762C22.661 3.23801 22.7076 3.53754 22.7292 3.85464C22.75 4.15925 22.75 4.53029 22.75 4.97475V5.02526C22.75 5.46972 22.75 5.84076 22.7292 6.14537C22.7076 6.46247 22.661 6.76199 22.5407 7.05238C22.2616 7.72621 21.7262 8.26156 21.0524 8.54067C20.762 8.66095 20.4625 8.7076 20.1454 8.72923C19.8408 8.75002 19.4697 8.75001 19.0253 8.75H16.9747C16.5303 8.75001 16.1592 8.75002 15.8546 8.72923C15.5375 8.7076 15.238 8.66095 14.9476 8.54067C14.2738 8.26156 13.7384 7.72621 13.4593 7.05238C13.3391 6.76199 13.2924 6.46247 13.2708 6.14537C13.25 5.84076 13.25 5.46971 13.25 5.02525V4.97474C13.25 4.53028 13.25 4.15925 13.2708 3.85464C13.2924 3.53754 13.3391 3.23801 13.4593 2.94762C13.7384 2.2738 14.2738 1.73844 14.9476 1.45933C15.238 1.33905 15.5375 1.29241 15.8546 1.27077C16.1592 1.24999 16.5303 1.25 16.9748 1.25H19.0253Z",
];

const DashboardIcon = ({ selected, width, height, className, ...props }) => {
  const id = useId().replace(/:/g, "");
  const gradientIds = paths.map(
    (_, index) => `dashboard-gradient-${index}-${id}`,
  );

  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g opacity={selected ? undefined : "0.5"}>
        {paths.map((path, index) => (
          <path key={path} d={path} fill={`url(#${gradientIds[index]})`} />
        ))}
      </g>
      <defs>
        {gradientIds.map((gradientId) => (
          <linearGradient
            key={gradientId}
            id={gradientId}
            x1="21.2616"
            y1="5.66516"
            x2="4.71924"
            y2="22.7058"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D946EF" />
            <stop offset="1" stopColor="#67E8F9" />
          </linearGradient>
        ))}
      </defs>
    </svg>
  );
};

DashboardIcon.propTypes = {
  selected: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

DashboardIcon.defaultProps = {
  selected: false,
  width: undefined,
  height: undefined,
  className: "",
};

export default DashboardIcon;
